<div id="kt_app_header" class="app-header">
  <div class="app-container container-xxl d-flex align-items-stretch justify-content-between"
    id="kt_app_header_container">
    <nav class="navbar navbar-expand-lg navbar-dark ">
      <div class="container-fluid">
        <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15">
          <a rounterlink="/">
            <img alt="Logo" src="assets/sacda_logo.png" class="logo  app-sidebar-logo-default" />
          </a>
        </div>
        <div class="title">
          <h1>WILD</h1>
        </div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav"
          aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- <div class="collapse navbar-collapse" id="main_nav1">



          <ul class="navbar-nav ms-auto">
            <li class="nav-item"><a class="nav-link" href="#">{{auth.currentUser.First_Name}}
                {{auth.currentUser.Last_Name}} </a></li>
            <li class="nav-item"><a class="nav-link" href="#">| {{date|date:'EEEE, MMM dd, yyyy'}} </a></li>
            <li class="nav-item"><a class="nav-link" href="#" (click)="auth.LogOut()">| Log Out</a></li>
          </ul>

        </div> -->
        <nav class="navbar  navbar-dark ">
          <div class="container-fluid">

            <div class="collapse navbar-collapse" id="navbarNavDarkDropdown">
              <ul class="navbar-nav">
                <li><input type="text" class="form-control form-control-sm" [(ngModel)]="search" (keypress)="Search($event)" placeholder="Search"></li>
                <li class="nav-item ">
                 
                  <a class="nav-link " href="#" id="navbarDarkDropdownMenuLink" role="button"
                  data-bs-toggle="dropdown" aria-expanded="true">
                  {{date|date:'EE, MMM dd, yyyy'}}&nbsp;&nbsp;|
                </a>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDarkDropdownMenuLink" role="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    {{auth.currentUser.First_Name}}
                    {{auth.currentUser.Last_Name}}
                  </a>
                  <ul class="dropdown-menu" aria-labelledby="navbarDarkDropdownMenuLink">
                    <!-- <li><a class="dropdown-item" >{{auth.currentUser.Agency_Name}}</a></li> -->
                  
                    <li><a class="dropdown-item" (click)="Open()"><i class="bi bi-key mr-5"></i>Change Password</a></li>
                    
                    <li><hr class="dropdown-divider"></li>
                    <li><a class="dropdown-item" (click)="auth.LogOut()"><i class="bi bi-power mr-5"></i> Logout</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div> <!-- container-fluid.// -->
    </nav>
  </div>
</div>

@if(nav.showMenu){
<div id="kt_app_header" class="card">
  <div class="card-body no-padding">
    <div class="app-container container-xxl d-flex align-items-stretch justify-content-between"
      id="kt_app_header_container">


      <nav class="navbar navbar-expand-lg navbar-light ">
        <div class="container-fluid">

          <div class="collapse navbar-collapse " id="main_nav">
            <ul class="navbar-nav navfont">
              <li class="nav-item menu-link px-3"><a class="navlink " routerLink="/home">Home</a></li>


              @for(item of auth.menus; track item){
              <li class="nav-item menu-link px-3"><a class=" navlink"
                  [ngClass]="{'navlinkactive':router.url==item.ahref}"
                  [routerLink]="item.ahref">{{item.HeaderDescription}}</a></li>
              }

            </ul>

          </div>
        </div>
      </nav>

    </div>

  </div>
</div>
}